exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-packages-index-js": () => import("./../../../src/pages/packages/index.js" /* webpackChunkName: "component---src-pages-packages-index-js" */),
  "component---src-pages-packages-supabase-package-name-js": () => import("./../../../src/pages/packages/{SupabasePackage.name}.js" /* webpackChunkName: "component---src-pages-packages-supabase-package-name-js" */)
}

